import { Controller } from "@hotwired/stimulus"

// Mirrors pointer movement from the hovered tile to every .admin-loupe
// sibling inside this container, so the magnifier on A, B, and Reference
// all follow the same relative position.
export default class extends Controller<HTMLElement> {
  private tiles: HTMLElement[] = []

  connect(): void {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return
    this.tiles = Array.from(this.element.querySelectorAll<HTMLElement>(".admin-loupe"))
    this.tiles.forEach((tile) => {
      tile.addEventListener("pointerenter", this.handleMove)
      tile.addEventListener("pointermove", this.handleMove)
      tile.addEventListener("pointerleave", this.handleLeave)
    })
  }

  disconnect(): void {
    this.tiles.forEach((tile) => {
      tile.removeEventListener("pointerenter", this.handleMove)
      tile.removeEventListener("pointermove", this.handleMove)
      tile.removeEventListener("pointerleave", this.handleLeave)
    })
    this.tiles = []
  }

  private handleMove = (event: PointerEvent): void => {
    const tile = event.currentTarget as HTMLElement
    const rect = tile.getBoundingClientRect()
    if (!rect.width || !rect.height) return
    const xpct = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1)
    const ypct = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1)
    this.broadcast({ xpct, ypct, active: true })
  }

  private handleLeave = (event: PointerEvent): void => {
    const next = event.relatedTarget as Node | null
    if (next && this.tiles.some((tile) => tile.contains(next))) return
    this.broadcast({ active: false })
  }

  private broadcast(detail: { xpct?: number; ypct?: number; active: boolean }): void {
    this.tiles.forEach((tile) => {
      tile.dispatchEvent(new CustomEvent("admin-loupe:sync", { detail }))
    })
  }
}
